export default __webpack_public_path__ + "icons/whaleFail-fb7ab1.svg";